export default __webpack_public_path__ + "static/media/LexusMonogram.b567478e.png";